import { render, staticRenderFns } from "./kalemcharter.vue?vue&type=template&id=d6cefb3c"
import script from "./kalemcharter.vue?vue&type=script&lang=js"
export * from "./kalemcharter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports